<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 1.5C15.3807 1.5 16.5 2.61929 16.5 4V14C16.5 15.3807 15.3807 16.5 14 16.5H4C2.61929 16.5 1.5 15.3807 1.5 14V4C1.5 2.61929 2.61929 1.5 4 1.5H14Z"
      :fill="color"
      :stroke="color"
    />
    <rect
      x="10"
      y="10"
      width="2"
      height="6"
      transform="rotate(-180 10 10)"
      fill="white"
    />
    <rect
      x="10"
      y="14"
      width="2"
      height="2"
      transform="rotate(-180 10 14)"
      fill="white"
    />
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: "#D47500",
    }
  },
};
</script>
